export class ResponseMuralModel{
    payload:MuralModel[];

    constructor(){
        this.payload = new Array<MuralModel>();
    }
}


export class MuralModel{
    idMural:number;
    idEtapa:number;
    idUsuario:number;
    texto:string;
    foto:string;
    constructor(){
        this.idMural = 0;
        this.idEtapa = 0;
        this.idUsuario = 0;
        this.texto = '';
        this.foto = '';
    }
}